import "./App.css";
import LandingPage from "./components/LandingPage";
import VideoPage from "./components/VideoPage";
import UploadModal from "./components/UploadModal"
// import { Switch } from "react-router";
import { Route, Switch, BowserRouter as Router } from "react-router-dom";

export const config = {
  endpoint: `https://c5fd1a85-447e-4f32-adb8-ec18366953e8.mock.pstmn.io/v1/videos`,
};

function App() {
  return (
    <div className="App">
        <Switch>
          <Route path="/" exact>
            <LandingPage></LandingPage>
          </Route>
          <Route exact path="/videos/:_id">
            <VideoPage></VideoPage>
          </Route>

          <Route path="/upload">
            <UploadModal></UploadModal>
          </Route>
        </Switch>
    </div>
  );
}

export default App;
